<section class="background">
    <img src="../../../../assets/img/dashboard/OrganizationalChart.png" alt="">
  </section>
